// Angular modules.
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiErrorResponse } from 'app/interfaces/error.interface';
import { ICalendarEvent } from 'app/interfaces/event.interface';
// Interfaces & Types
import { ErrorService } from 'app/services/error.service';
// Services
import { EventsService } from 'app/services/events.service';
import { UserService } from 'app/services/user.service';

@Component({
	selector: 'app-appointments-reasons-survey',
	templateUrl: './reasons.component.html',
	styleUrls: ['./reasons.component.scss'],
})
export class ReasonsComponent implements OnInit {
	starting = true;
	error: string | null = null;
	appointmentId: string | null = null;
	event: ICalendarEvent;

	constructor(
		protected router: Router,
		protected events: EventsService,
		protected route: ActivatedRoute,
		private errorService: ErrorService,
		private user: UserService
	) {}

	// On init.
	async ngOnInit() {
		this.appointmentId = this.route.snapshot.queryParamMap.get('appointmentId');

		this.events.getEventInServer(this.appointmentId).subscribe(
			(appointment) => {
				this.starting = false;
				this.event = appointment as ICalendarEvent;
			},
			(error: ApiErrorResponse) => {
				this.starting = false;
				this.error = this.errorService.getMessage(error.error);
			}
		);
	}

	goHome() {
		this.router.navigateByUrl('/').then(() => (this.starting = false));
	}
}
